import { Component, OnInit, Input, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";

import { QuoteInfoService } from "../../services/quote-info.service";
import { ApplicationStateService } from "../../services/application-state.service";
import { QuoteSummaryService } from "../../services/quote-summary.service";
import { PageTitleService } from "../../services/page-title.service";
import { BrowserWidthService } from "../../services/browser-width.service";

@Component({
    selector: 'quote-info',
    template: require('./quote-info.component.html'),
    styles: [require('./quote-info.component.scss')]
})

export class QuoteInfoComponent implements OnInit, OnDestroy {
    pricingView: number;
    quoteId: number;
    homePrice: number;
    pageWidth: number;

    showPricingView: boolean;
    customerTransportation: number = 0;
    customerSurcharge: number = 0;
    subscription: Subscription = new Subscription();

    constructor(
        protected quoteInfoService: QuoteInfoService,
        protected applicationStateService: ApplicationStateService,
        protected quoteSummaryService: QuoteSummaryService,
        private pageTitleService: PageTitleService,
        private browserWidthService: BrowserWidthService
    ) {
        const currentPricingViewSub = this.quoteInfoService.currentPricingView$.subscribe(x => {
            this.pricingView = x;
            this.quoteSummaryService.calculatePrices();

            const pageNameSub = this.pageTitleService.pageName.subscribe(x => {
                if (this.pricingView === 3) {
                    this.showPricingView = false;
                    this.quoteInfoService.showPricingView$.next(this.showPricingView);
                } else {
                    if ((x === 'Model' || x === 'Product Lines') && this.pricingView !== 2) {
                        this.showPricingView = false;
                        this.quoteInfoService.showPricingView$.next(this.showPricingView);
                    } else {
                        this.showPricingView = true;
                        this.quoteInfoService.showPricingView$.next(this.showPricingView);
                    }
                }
            });
            this.subscription.add(pageNameSub);
        });
        this.subscription.add(currentPricingViewSub);

        const pageNameSub = this.pageTitleService.pageName.subscribe(x => {
            if (this.pricingView === 3) {
                this.showPricingView = false;
                this.quoteInfoService.showPricingView$.next(this.showPricingView);
            } else {
                if ((x === 'Model' || x === 'Product Lines') && this.pricingView !== 2) {
                    this.showPricingView = false;
                    this.quoteInfoService.showPricingView$.next(this.showPricingView);
                } else {
                    this.showPricingView = true;
                    this.quoteInfoService.showPricingView$.next(this.showPricingView);
                }
            }
        });
        this.subscription.add(pageNameSub);

        const quoteSummarySub = this.quoteInfoService.quoteSummary$.subscribe(x => {
            if (this.pricingView === 1) {
                if (x !== undefined && x !== null) {
                    this.homePrice = x.BaseCost + (x.Dues - this.customerTransportation - this.customerSurcharge);
                } else {
                    this.homePrice = 0.00;
                }
            }
        });
        this.subscription.add(quoteSummarySub);
    }

    ngOnInit() {
        this.pageWidth = this.browserWidthService.getDisplayMode().width.innerWidth;
        const quoteSub = this.quoteInfoService.quote$.subscribe(x => {
            this.quoteId = x.quoteId;
            if (this.quoteId) {
                this.quoteInfoService.quoteId$.next(x.quoteId);
                this.quoteInfoService.customerId$.next(x.customerId);
                this.applicationStateService.setQuote(x);

                const canAccessQuoteSub = this.quoteInfoService.canAccessQuote$.subscribe(canAccessQuote => {
                    if (canAccessQuote === true) {
                        this.quoteSummaryService.getPricingHeader(this.quoteId).subscribe(x => {
                            this.customerSurcharge = x.Surcharge;
                            this.customerTransportation = x.Transportation;
                            this.quoteInfoService.adjustment$.next(x.AdjustmentInfo);
                        });
                    } else {
                        this.showPricingView = false;
                        this.quoteInfoService.showPricingView$.next(this.showPricingView);
                    }
                });
                this.subscription.add(canAccessQuoteSub);
            }
        });
        this.subscription.add(quoteSub);
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/reusable-components/quote-info/quote-info.component.ts